import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=78bc14a9&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=78bc14a9&prod&scoped=true&lang=less"
import style1 from "./BaseTable.vue?vue&type=style&index=1&id=78bc14a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc14a9",
  null
  
)

export default component.exports